const getApiBaseUrl = () => {
    return process.env.REACT_APP_IS_PROD === 'TRUE'
        ? process.env.REACT_APP_API_URL
        : process.env.REACT_APP_APITEST_URL;
};

export default getApiBaseUrl;